import { render, staticRenderFns } from "./SynchronizationAssesment.vue?vue&type=template&id=5703b8a1&"
import script from "./SynchronizationAssesment.vue?vue&type=script&lang=js&"
export * from "./SynchronizationAssesment.vue?vue&type=script&lang=js&"
import style0 from "./SynchronizationAssesment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports